(function () {
  'use strict';

  function initPressLogos(sectionId) {
    var grid        = document.getElementById('press-logos-grid-' + sectionId);
    var toggleWrap  = document.getElementById('press-logos-toggle-wrap-' + sectionId);
    var btn         = toggleWrap ? toggleWrap.querySelector('.press-logos__toggle') : null;

    if (!grid || !btn) return;

    var labelMore = btn.dataset.labelMore || 'Show all publications';
    var labelLess = btn.dataset.labelLess || 'Show fewer';

    // Mobile breakpoint – match the CSS rule above
    var MOBILE_MAX = 749;
    var ROW_LIMIT   = 3; // visible rows before collapse

    function isMobile() {
      return window.innerWidth <= MOBILE_MAX;
    }

    function getRowHeight() {
      // Use the first item to measure a single row's occupied height
      var items = grid.querySelectorAll('.press-logos__item');
      if (!items.length) return 0;
      var firstTop = items[0].getBoundingClientRect().top;
      var rowH = 0;
      for (var i = 0; i < items.length; i++) {
        var top = items[i].getBoundingClientRect().top;
        if (top > firstTop + 2) { // small tolerance for sub-pixel
          rowH = top - firstTop;
          break;
        }
      }
      // Fallback: measure the item itself if all items share one row
      if (!rowH) {
        rowH = items[0].getBoundingClientRect().height;
      }
      return rowH;
    }

    function getGridGapV() {
      // Read the computed row-gap from the grid
      var style = window.getComputedStyle(grid);
      return parseFloat(style.rowGap) || 10;
    }

    function applyCollapse() {
      if (!isMobile()) {
        // Desktop – always show everything, no toggle
        grid.classList.remove('is-collapsed');
        grid.style.removeProperty('--press-logos-collapsed-height');
        grid.removeAttribute('aria-expanded');
        toggleWrap.style.display = 'none';
        return;
      }

      // Temporarily expand to measure full natural height
      grid.classList.remove('is-collapsed');
      grid.style.removeProperty('--press-logos-collapsed-height');

      var totalHeight   = grid.scrollHeight;
      var rowH          = getRowHeight();
      var gap           = getGridGapV();
      var collapsedH    = (rowH * ROW_LIMIT) + (gap * (ROW_LIMIT - 1));

      if (totalHeight <= collapsedH + rowH * 0.5) {
        // Grid fits within the row limit – no toggle needed
        toggleWrap.style.display = 'none';
        grid.removeAttribute('aria-expanded');
        return;
      }

      // Grid overflows – apply collapsed state
      toggleWrap.style.display = 'block';
      grid.style.setProperty('--press-logos-collapsed-height', collapsedH + 'px');

      var isExpanded = grid.getAttribute('aria-expanded') === 'true';
      if (!isExpanded) {
        grid.classList.add('is-collapsed');
        grid.setAttribute('aria-expanded', 'false');
        btn.setAttribute('aria-expanded', 'false');
        btn.textContent = labelMore;
      }
    }

    btn.addEventListener('click', function () {
      var expanded = grid.getAttribute('aria-expanded') === 'true';
      if (expanded) {
        grid.classList.add('is-collapsed');
        grid.setAttribute('aria-expanded', 'false');
        btn.setAttribute('aria-expanded', 'false');
        btn.textContent = labelMore;
      } else {
        grid.classList.remove('is-collapsed');
        grid.setAttribute('aria-expanded', 'true');
        btn.setAttribute('aria-expanded', 'true');
        btn.textContent = labelLess;
      }
    });

    // Run on load and on resize (debounced)
    applyCollapse();
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(applyCollapse, 150);
    });
  }

  // Initialise all press-logos sections on the page
  document.querySelectorAll('[id^="press-logos-grid-"]').forEach(function (el) {
    var sectionId = el.id.replace('press-logos-grid-', '');
    initPressLogos(sectionId);
  });
})();